module.exports = __webpack_public_path__ + "img/border.c71fe878.png";